import { z } from 'zod';

// Zod's object fast path compiles parsers with `new Function`, which our CSP
// (`script-src` without 'unsafe-eval') reports and, once enforced, blocks.
// Zod reads this flag when each schema is constructed, so every app imports
// this module first in its entry, before any module that defines a schema.
z.config({ jitless: true });
